import {Provider} from '@angular/core';
import {IMAGE_LOADER, ImageLoaderConfig} from '@angular/common';
import {environment} from '../../../environments/environment';

export function provideCdnUrlReplacer(): Provider {
	return {
		provide: IMAGE_LOADER,
		useValue: (config: ImageLoaderConfig) => {
			if(config.src.startsWith(environment.aws.s3Bucket)) {
				return config.src.replace(environment.aws.s3Bucket, environment.aws.cloudfrontHost);
			}
			if(config.src.startsWith('/assets/') || config.src.startsWith('assets/')) {
				const url = new URL(config.src, environment.aws.cloudfrontHost);
				return url.toString();
			}
			return config.src;
		},
	};
}

